import { getApiClient } from "../../../libs/ApiClient";

export type Account = {
  id: string;
  name: string;
  code: string;
  active: boolean;
};
export type AccountList = {
  accounts: Array<Account>;
  totalCount: number;
};
export function getAccountList(
  getAccessToken: () => Promise<string>,
  signal?: AbortSignal
) {
  const client = getApiClient(getAccessToken);
  return client.then((client) => {
    return client
      .get<AccountList>(`/accounts/v2`, { signal: signal })
      .then((response) => response.data);
  });
}
